import _ from "lodash";
import ErrorUtils from "../../utils/errors";

export function parseContentServiceError(error) {
  const { data, status } = error;

  let message = ErrorUtils.getStatusCodeErrorMessage(status);
  if (data.error) {
    if (_.isArray(data.error)) {
      message = data.error
        .map((err) => (_.isObject(err) ? err.message : err))
        .join(",");
    } else {
      message = _.isObject(data.error) ? data.errors.message : data.error;
    }
  } else {
    if (data?.error?.message) message = data.error.message;
  }
  return message;
}
